import type { ComponentWithAs, IconProps } from '@chakra-ui/react';
import { Center, Text } from '@chakra-ui/react';

import { Option } from '@revelio/ui';

import styles from './SelectionOptionCard.module.css';

type SelectionOptionCardProps = {
  testId: string;
  label: string;
  description: string;
  icon: ComponentWithAs<'svg', IconProps>;
  isDisabled: boolean;
  isSelected: boolean;
  onClick?: () => void;
};

export const SelectionOptionCard = ({
  testId,
  label,
  description,
  icon: IconComponent,
  isDisabled,
  isSelected,
  onClick,
}: SelectionOptionCardProps) => {
  return (
    <Option
      data-testid={testId}
      className={styles.card}
      disabled={isDisabled}
      isSelected={isSelected}
      onClick={onClick}
      startSlot={
        <Center
          className={styles.iconBadge}
          w={12}
          h={12}
          borderRadius="full"
          bg="gray.100"
        >
          <IconComponent boxSize={6} color="gray.600" />
        </Center>
      }
    >
      <Text className={styles.title} fontWeight="semibold" fontSize="sm">
        {label}
      </Text>
      <Text
        className={styles.description}
        fontSize="xs"
        color="gray.500"
        mt={0.5}
      >
        {description}
      </Text>
    </Option>
  );
};
